import { createI18n } from 'vue-i18n';
import tr from '../locales/tr.json';
import en from '../locales/en.json';

const SUPPORTED_LOCALES = ['tr', 'en'];

function resolveInitialLocale() {
  const saved = (typeof localStorage !== 'undefined')
    ? localStorage.getItem('selectedLanguage')
    : null;
  if (saved && SUPPORTED_LOCALES.includes(saved)) {
    return saved;
  }
  return 'tr';
}

const isDev = process.env.NODE_ENV !== 'production';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: resolveInitialLocale(),
  fallbackLocale: 'tr',
  missingWarn: isDev,
  fallbackWarn: isDev,
  silentTranslationWarn: !isDev,
  silentFallbackWarn: !isDev,
  messages: {
    tr,
    en,
  },
});

export default i18n;
export { SUPPORTED_LOCALES };
